export const TICKET_PERMISSION_IDS = ['customers'] as const;

export function hasTicketAccess(
  menuPermissions: string[] | null | undefined,
): boolean {
  if (!Array.isArray(menuPermissions)) return true;
  return TICKET_PERMISSION_IDS.some((id) => menuPermissions.includes(id));
}
